import { Button, Col, Empty, Flex, message, Popover, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./style.css";
import API from "../../../services/api-request";
import LayoutColdStorage from "./layout-cold-storage";
import UserManualButton from "../../../components/UserManualButton";

const StockOpname = () => {
  const [selectedStorage, setSelectedStorage] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [temporarySelected, setTemporarySelected] = useState(false);
  const [layoutSelected, setLayoutSelected] = useState(false);

  const navigate = useNavigate();

  const handleNavigate = (id, name, row, section, temporary) => {
    if (!name) return;

    const codifiedName = temporary
      ? "T-CS" + name.split(" ")[2]
      : "CS" + name.split(" ")[2];

    navigate(`/detail-stock/${codifiedName}-${row}${section}`, {
      state: { id, row, section, name: codifiedName },
    });
  };

  const getAreaData = (id) => {
    setLoading(true);

    API.Get(`area/map`)
      .then((res) => {
        const data = res?.data;
        if (id) {
          setSelectedStorage(
            data.filter((item) => item.warehouse_id === id)[0],
          );
        } else {
          setSelectedStorage(data[0]);
        }
        setWarehouses(
          data.map((item) => ({
            id: item.warehouse_id,
            warehouse_name: item.warehouse_name,
          })),
        );
      })

      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch area data!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAreaData();
  }, []);

  return (
    <>
      <Flex gap={8}>
        {warehouses.map(
          (item, index) =>
            !item.warehouse_name.includes("Temporary") && (
              <Button
                variant={
                  selectedStorage?.warehouse_name === item?.warehouse_name &&
                  !layoutSelected
                    ? "solid"
                    : "outlined"
                }
                color="primary"
                style={{
                  borderRadius: 20,
                  padding: "1rem",
                }}
                key={index}
                onClick={() => {
                  setTemporarySelected(false);
                  setLayoutSelected(false);
                  getAreaData(item?.id);
                }}
              >
                {item?.warehouse_name}
              </Button>
            ),
        )}
        <Popover
          content={
            <Row gutter={8}>
              {warehouses.map(
                (item, index) =>
                  item.warehouse_name.includes("Temporary") && (
                    <Col span={8}>
                      <Button
                        variant={
                          selectedStorage?.warehouse_name ===
                          item?.warehouse_name
                            ? "solid"
                            : "outlined"
                        }
                        color="primary"
                        style={{
                          borderRadius: 20,
                          padding: "1rem",
                        }}
                        key={index}
                        onClick={() => {
                          setTemporarySelected(true);
                          setLayoutSelected(false);
                          getAreaData(item?.id);
                        }}
                      >
                        {item?.warehouse_name}
                      </Button>
                    </Col>
                  ),
              )}
            </Row>
          }
        >
          <Button
            variant={temporarySelected ? "solid" : "outlined"}
            color="primary"
            style={{
              borderRadius: 20,
              padding: "1rem",
            }}
          >
            Temporary Area
          </Button>
        </Popover>
        <Popover
          content={
            <Row gutter={8}>
              {warehouses.map(
                (item, index) =>
                  !item.warehouse_name.includes("Temporary") && (
                    <Col span={8}>
                      <Button
                        variant={
                          selectedStorage?.warehouse_name ===
                            item.warehouse_name && layoutSelected
                            ? "solid"
                            : "outlined"
                        }
                        color="primary"
                        style={{
                          borderRadius: 20,
                          padding: "1rem",
                        }}
                        key={index}
                        onClick={() => {
                          setTemporarySelected(false);
                          setLayoutSelected(true);
                          getAreaData(item?.id);
                        }}
                      >
                        {item?.warehouse_name}
                      </Button>
                    </Col>
                  ),
              )}
            </Row>
          }
        >
          <Button
            variant={layoutSelected ? "solid" : "outlined"}
            color="primary"
            style={{
              borderRadius: 20,
              padding: "1rem",
            }}
          >
            Layout Cold Storage
          </Button>
        </Popover>
        <div style={{ width: "fit-content", marginLeft: "auto" }}>
          <UserManualButton />
        </div>
      </Flex>
      {selectedStorage?.rows?.length > 0 ? (
        loading ? (
          <Flex justify="center" align="center" style={{ marginTop: "10rem" }}>
            <Spin size="large" />
          </Flex>
        ) : (
          <Row gutter={8}>
            {!layoutSelected &&
              selectedStorage?.rows.map((row, index) => (
                <Col span={4} key={index}>
                  <Flex justify="center">
                    <div>
                      <h2 style={{ textAlign: "center" }}>{row?.row_number}</h2>
                      <Row gutter={4}>
                        {row?.sections?.map((section, index) => (
                          <Col
                            key={index}
                            span={row?.sections?.length > 1 ? 12 : 24}
                          >
                            <Button
                              color="primary"
                              variant="outlined"
                              className="section-button"
                              onClick={() => {
                                handleNavigate(
                                  selectedStorage?.warehouse_id,
                                  selectedStorage?.warehouse_name,
                                  row?.row_number,
                                  section?.section,
                                  selectedStorage.warehouse_name.includes(
                                    "Temporary",
                                  )
                                    ? true
                                    : false,
                                );
                              }}
                            >
                              <div style={{ fontSize: 12 }}>
                                {section?.section}
                                <br />
                                {section?.occupied_areas +
                                  "/" +
                                  (+section?.empty_areas +
                                    +section?.occupied_areas)}
                                <div>
                                  {Math.round(section?.total_weight)} Kg
                                </div>
                              </div>
                            </Button>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Flex>
                </Col>
              ))}

            <Col span={24}>
              {layoutSelected && (
                <LayoutColdStorage
                  selectedStorage={selectedStorage}
                  loading={loading}
                />
              )}
            </Col>
          </Row>
        )
      ) : loading ? (
        <Flex justify="center" align="center" style={{ marginTop: "10rem" }}>
          <Spin size="large" />
        </Flex>
      ) : (
        <Empty
          // description="Choose Storage"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ marginTop: "10rem" }}
        />
      )}
    </>
  );
};

export default StockOpname;
